module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-module/master-module.component.scss
// module id = ./src/app/master/master-module/master-module.component.scss
// module chunks = main